<template>
  <div class="tabs-list">
    <div
      :key="id"
      v-for="(tab, id) in tabs"
      class="tab-list-item"
      v-on:click="setTab(id)"
      v-bind:class="{ active: activeTab == id }"
    >
      {{ tab.name }}
    </div>
    <div v-if="this.activeTab === 'calls'" class="tab-list-item indication-information-wrapper">
      <div class="indication-information-item">
        <div class="indication-circle-grey"></div>
        <div class="tooltip" style="color: #5C7069;">
          Regular call
        </div>
      </div>
      <div class="indication-information-item">
        <div class="indication-circle-red"></div>
        <div class="tooltip" style="color: #F99E98;">
          Sneak Peek sent
        </div>
      </div>
    </div>

    <div v-if="this.activeTab === 'preshipping' || activeTab === 'sp'" class="tab-list-item indication-information-wrapper preshipping-indication-position">
      <div v-if="false" class="indication-information-item">
        <div class="indication-circle-red"></div>
        <div class="tooltip" style="color: #F99E98;">
          Need new Sneak Peek
        </div>
      </div>
      <div class="indication-information-item">
        <div class="indication-circle-grey"></div>
        <div class="tooltip" style="color: #5C7069;">
          Ready to be finalized Sneak Peek
          <!-- <span class="tooltiptext">Tooltip text</span> -->
        </div>
      </div>
      <div class="indication-information-item">
        <div class="indication-circle-skyblue"></div>
        <div class="tooltip" style="color: #B6D7FF;">
          Ready to be finalized surprise box
        </div>
      </div>
      <div class="indication-information-item">
        <div class="indication-circle-orange"></div>
        <div class="tooltip"  style="color: orange;">
          Abandoned (Saw 5+ over 24h ago)
        </div>
      </div>
    </div>

    <div v-if="this.activeTab === 'preshipping_outstanding' || activeTab === 'outstanding'" class="tab-list-item indication-information-wrapper preshipping-indication-position">
      <div class="indication-information-item">
        <div class="indication-circle-red"></div>
        <div class="tooltip"  style="color: #F99E98;">
           No feedback
        </div>
      </div>
      <div class="indication-information-item">
        <div class="indication-circle-grey"></div>
        <div class="tooltip"  style="color: #5C7069;">
          No additional feedback
          <span class="tooltiptext">Stylist has sent additional Sneak Peek after customer request but did not reply</span>
        </div>
      </div>
      <div class="indication-information-item">
        <div class="indication-circle-orange"></div>
        <div class="tooltip"  style="color: orange;">
          Abandoned
        </div>
      </div>
    </div>

    <div class="filler"></div>
  </div>
</template>

<script>
export default {
  props: ['tabs', 'value'],
  computed: {
    activeTab: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    setTab (id) {
      this.activeTab = id

      this.$emit('change', {
        id: id
      })
    }
  }
}
</script>

<style scoped lang="less">
.indication-information-wrapper {
  display: block;
  margin-left: auto;
  border: none;
  transform: translateY(-4px);
  &:hover {
    border: none;
    cursor: unset;
  }
}
.indication-information-item {
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.preshipping-indication-position {
  transform: translateY(-24px);
}
.indication-circle-red {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: pink;
}
.indication-circle-orange {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: orange;
}
.indication-circle-grey {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #f2f2f2;
}
.indication-circle-skyblue {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #B6D7FF;
}
.tooltip {
  position: relative;
  display: inline-block;
  color: #3d74ab;
  margin-left: 12px;
  font-size: 14px;
  .tooltiptext {
    visibility: hidden;
    width: 180px;
    font-size: 13px;
    background-color: #e6e6e6;
    color: #000000;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    top: 150%;
    left: 50%;
    margin-left: -60px;
    &::after {
      content: "";
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent #e6e6e6 transparent;
    }
  }
  &:hover {
    .tooltiptext {
      visibility: visible;
    }
  }
}

</style>
